import { render, staticRenderFns } from "./infoSelectLoginErrorPage.vue?vue&type=template&id=b5faf9fa&scoped=true&"
import script from "./infoSelectLoginErrorPage.vue?vue&type=script&lang=js&"
export * from "./infoSelectLoginErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5faf9fa",
  null
  
)

export default component.exports